<template>
  <v-toolbar flat class="elevation-1 sticky toolbar-scroll">
    <v-btn large flat href="#pluma">
      {{ __('CDA') }}
    </v-btn>
    <v-btn large flat href="#executives">
      {{ __('Meet our Executives') }}
    </v-btn>
    <v-btn large flat href="#trainers">
      {{ __('Meet our Trainers') }}
    </v-btn>
    <v-btn large flat href="#pluma">
      {{ __('Major Areas') }}
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: 'AnchorNav',
}
</script>
